module.exports = __webpack_public_path__ + "img/building.1675f24b.svg";